module.exports = "<div class=legal-container> <div class=privacy> <h3>Privacy Policy</h3> </div> </div>";